module.exports = require("./ug-CN.js");